import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import api from "../../../helper/api";
import {
  exportSchoolSuccess,
  exportSchoolFailure,
  exportStudentSuccess,
  exportStudentFailure,
  exportTeacherSuccess,
  exportTeacherFailure,
} from "../../Actions/school-management/export-actions";
import {
  EXPORT_SCHOOL,
  EXPORT_STUDENT,
  EXPORT_TEACHER,
} from "../../Actions/types";

function* exportSchool(action) {
  try {
    const response = yield api.get(`/admin/school/export-file`);
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        exportSchoolSuccess({ exportSchoolData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(exportSchoolFailure({ exportSchoolError: e }));
  }
}

function* exportStudent(action) {
  try {
    const response = yield api.get(
      `/admin/school/student/export-file/${action?.payload?.form?.schoolId}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        exportStudentSuccess({ exportStudentData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(exportStudentFailure({ exportStudentError: e }));
  }
}

function* exportTeacher(action) {
    try {
      const response = yield api.get(
        `/admin/school/teacher/export-file/${action?.payload?.form?.schoolId}`
      );
      if (response?.status === 200 && response?.data?.code === 200) {
        yield call(action?.payload?.callback, response?.data?.data);
        yield put(
          exportTeacherSuccess({ exportTeacherData: response?.data?.data })
        );
      } else if (response?.status === 200 && response?.data?.code !== 200) {
        toast.error(response?.data?.message);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message);
      yield put(exportTeacherFailure({ exportTeacherError: e }));
    }
  }

function* exportStudentWatcher() {
  yield takeLatest(EXPORT_STUDENT, exportStudent);
}

function* exportSchoolWatcher() {
  yield takeLatest(EXPORT_SCHOOL, exportSchool);
}

function* exportTeacherWatcher() {
    yield takeLatest(EXPORT_TEACHER, exportTeacher);
  }

export default function* exportManagementSaga() {
  yield all([exportStudentWatcher(), exportSchoolWatcher(), exportTeacherWatcher()]);
}
